// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallVideoButton__check-icon-daa310 {
  margin-inline-start: 8px;
}

.CallVideoButton__menu-title-e2c571 {
  font: var(--font-body-4);
  color: var(--addition-50_70);
  opacity: 1 !important;
  letter-spacing: var(--font-spacing-body-4);
}

.CallVideoButton__menu-title-e2c571:hover,
.CallVideoButton__menu-title-e2c571:focus,
.CallVideoButton__menu-title-e2c571:active {
  background-color: transparent;
}

.CallVideoButton__background-panel-delimeter-bbc6fe {
  border-top: 1px solid var(--addition-50_10);
  margin: 8px 16px;
  max-width: calc(100% - 32px);
  min-height: 0;
  cursor: initial;
}

.CallVideoButton__popover-c6636c {
  background-color: var(--light-10-addition-120);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/CallActionsPanel/CallVideoButton/CallVideoButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,wBAAA;EACA,4BAAA;EACA,qBAAA;EACA,0CAAA;AACF;;AAEA;;;EAGE,6BAAA;AACF;;AAEA;EACE,2CAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,eAAA;AACF;;AAEA;EACE,8CAAA;AACF","sourcesContent":[".check-icon {\n  margin-inline-start: 8px;\n}\n\n.menu-title {\n  font: var(--font-body-4);\n  color: var(--addition-50_70);\n  opacity: 1 !important;\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.menu-title:hover,\n.menu-title:focus,\n.menu-title:active {\n  background-color: transparent;\n}\n\n.background-panel-delimeter {\n  border-top: 1px solid var(--addition-50_10);\n  margin: 8px 16px;\n  max-width: calc(100% - 32px);\n  min-height: 0;\n  cursor: initial;\n}\n\n.popover {\n  background-color: var(--light-10-addition-120);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"check-icon": `CallVideoButton__check-icon-daa310`,
	"checkIcon": `CallVideoButton__check-icon-daa310`,
	"menu-title": `CallVideoButton__menu-title-e2c571`,
	"menuTitle": `CallVideoButton__menu-title-e2c571`,
	"background-panel-delimeter": `CallVideoButton__background-panel-delimeter-bbc6fe`,
	"backgroundPanelDelimeter": `CallVideoButton__background-panel-delimeter-bbc6fe`,
	"popover": `CallVideoButton__popover-c6636c`
};
module.exports = ___CSS_LOADER_EXPORT___;
